import { render, staticRenderFns } from "./fundRiskFilter.vue?vue&type=template&id=6f06e652"
import script from "./fundRiskFilter.vue?vue&type=script&lang=js"
export * from "./fundRiskFilter.vue?vue&type=script&lang=js"
import style0 from "./fundRiskFilter.vue?vue&type=style&index=0&id=6f06e652&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports